import i18n from '~/i18n';

export const IC_LOOKUP_ENABLED_COUNTRIES = ['CZ', 'PL', 'SK'];
export const NAME_LOOKUP_ENABLED_COUNTRIES = ['CZ', 'PL', 'SK'];
export const TARIF_PREMIUM = 'Premium';
export const DEFAULT_CURRENCY = 'CZK';
export const BANK_TRANSFER = 'bank_transfer';
export const CREDIT_CARD = 'credit_card';
export const MINI_PLAN_ID = 1;
export const PREMIUM_PLAN_ID = 2;

export const COUNTRY_CODES = {
  CS: 'CZ',
  EN: 'US',
  PL: 'PL',
  RS: 'RS',
  SK: 'SK',
  NL: 'NL',
  GB: 'GB',
  DE: 'DE',
  ES: 'ES',
};

export const LANGUAGES = {
  CS: 'cs',
  EN: 'en',
  PL: 'pl',
  RS: 'en-RS',
  SK: 'sk',
  NL: 'nl-NL',
  GB: 'en',
  DE: 'de-DE',
  ES: 'es-ES',
};

export const CURRENCIES = {
  CS: 'CZK',
  EN: 'USD',
  PL: 'PLN',
  RS: 'RSD',
  SK: 'EUR',
  NL: 'EUR',
  GB: 'GBP',
  DE: 'EUR',
  ES: 'EUR',
};

export const AVAILABLE_TABLE_COLUMNS = [
  'number',
  'seller_name',
  'buyer_name',
  'issued_on',
  'due_on',
  'tax_point_on',
  'paid_at',
  'submitted_at',
  'kind',
  'total_float',
  'state',
];

export const DEFAULT_CONTACTS_COLUMNS = ['name', 'company_number', 'email', 'phone', 'invoices_count'];
export const DISABLED_CONTACTS_STATE_COLUMNS = ['company_number', 'name'];
export const AVAILABLE_CONTACTS_TABLE_COLUMNS = [
  'name',
  'company_number',
  'email',
  'phone',
  'invoices_count',
  'expenses_count',
];

export const DEFAULT_EXPENSES_COLUMNS = ['number', 'state', 'attachment', 'contact_id', 'due_on', 'total_amount'];
export const DISABLED_EXPENSES_STATE_COLUMNS = ['number'];
export const AVAILABLE_EXPENSES_TABLE_COLUMNS = [
  'number',
  'attachment',
  'contact_id',
  'due_on',
  'amount_without_tax',
  'total_amount',
  'state',
];

export const AVAILABLE_INVOICES_FILTERS = ['period', 'customer', 'kind', 'price'];
export const DEFAULT_INVOICES_FILTERS = ['period', 'customer'];
export const DISABLED_INVOICES_FILTERS = ['period'];

export const AVAILABLE_EXPENSES_FILTERS = ['period', 'customer', 'price'];
export const DEFAULT_EXPENSES_FILTERS = ['period', 'customer'];
export const DISABLED_EXPENSES_FILTERS = ['period'];

export const STATE_COLUMNS = ['state', 'paid_at', 'submitted_at'];
export const DEFAULT_COLUMNS = ['number', 'state', 'buyer_name', 'due_on', 'kind', 'total_float'];
export const DISABLED_STATE_COLUMNS = ['number', 'total_float'];
export const ENV_COUNTRIES = { CZ: 'cz' };
export const VAT_INCLUSIVE = 'vat_inclusive';
export const VAT_EXCLUSIVE = 'vat_exclusive';
export const NEW_INVOICE = 'new';
export const PREMIUM_PLAN_NAME = 'Premium';
export const MINI_PLAN_NAME = 'Mini';
export const EDIT_INVOICE = 'edit';
export const INVOICE_KIND_NO_VAT = 'invoice';
export const INVOICE_KIND_WITH_VAT = 'vat_invoice';
export const INVOICE_KIND_ADVANCE = 'advance';
export const INVOICE_KIND_PROFORMA = 'proforma';
export const INVOICE_KIND_VAT_MARGIN = 'vat_margin_invoice';
export const INVOICE_KIND_VAT_DUTY_REVERSED = 'vat_duty_reversed';
export const EET_REQUIRED_MEANS_OF_PAYMENT = ['cash'];
export const EXPIRE_SUBSCRIPTION_THRESHOLD_DAYS = 30;

export const FETCH_STATE_NONE = 'FETCH_STATE_NONE';
export const FETCH_STATE_PENDING = 'FETCH_STATE_PENDING';
export const FETCH_STATE_SUCCESS = 'FETCH_STATE_SUCCESS';
export const FETCH_STATE_ERROR = 'FETCH_STATE_ERROR';

const currency = CURRENCIES[i18n.locale.toUpperCase()];

export const FAKE_INVOICES = new Array(10).fill(0).map((i, index) => ({
  _id: '5d1342259f880b42b7929f30',
  number: 124 - index,
  createdAt: '2019-06-26T12:00:05.810+02:00',
  buyer: { name: 'FakturaOnline s.r.o' },
  seller: { name: 'FakturaOnline s.r.o' },
  kind: 'invoice',
  dueOn: new Date(),
  totalFloat: Math.floor(Math.random() * 10545),
  eetInvoice: false,
  eetState: 'not_subject',
  language: i18n.locale.toUpperCase(),
  state: ['overdue', 'paid', 'submitted'][Math.floor(Math.random() * 3)],
  currency,
}));

export const FAKE_INVOICES_STATES = {
  baseCurrency: currency,
  invoicesCount: 40,
  invoicesSum: 2000000 + Math.random() * 100000,
  overdueCount: 4,
  overdueSum: 300000 + Math.random() * 50000,
  paidCount: 22,
  paidSum: 350000 + Math.random() * 50000,
  proposalCount: 6,
  proposalSum: 1100000 + Math.random() * 50000,
  recurringCount: 3,
  recurringSum: 120000 + Math.random() * 10000,
  submittedCount: 5,
  submittedSum: 120000 + Math.random() * 10000,
};

const FAKE_INVOICES_KINDS = {
  all: 40,
  byKind: [
    {
      kind: 'tax_invoice',
      count: 18,
    },
    {
      kind: 'invoice',
      count: 6,
    },
    {
      kind: 'proforma_invoice',
      count: 4,
    },
    {
      kind: 'receipt',
      count: 3,
    },
    {
      kind: 'sales_receipt',
      count: 2,
    },
    {
      kind: 'cash_receipt',
      count: 1,
    },
    {
      kind: 'quote',
      count: 4,
    },
    {
      kind: 'estimate',
      count: 2,
    },
  ],
};

export const FAKE_INVOICES_USA = new Array(10).fill(0).map((i, index) => ({
  _id: '5d1342259f880b42b7929f30',
  number: 124 - index,
  createdAt: '2019-06-26T12:00:05.810+02:00',
  buyer: 'FakturaOnline s.r.o., Křížová 2598/4, Smíchov, 150 00 Praha 5',
  seller: 'FakturaOnline s.r.o., Křížová 2598/4, Smíchov, 150 00 Praha 5',
  kind: FAKE_INVOICES_KINDS.byKind[Math.floor(Math.random() * FAKE_INVOICES_KINDS.byKind.length)].kind,
  dueOn: new Date(),
  totalFloat: Math.floor(Math.random() * 10545),
  eetInvoice: false,
  eetState: 'not_subject',
  language: i18n.locale.toUpperCase(),
  state: ['proposal', 'paid', 'submitted'][Math.floor(Math.random() * 3)],
  currency: 'USD',
}));

export const FAKE_INVOICES_STATES_USA = {
  baseCurrency: currency,
  invoicesCount: 40,
  invoicesSum: 2000000 + Math.random() * 100000,
  overdueCount: 4,
  overdueSum: 300000 + Math.random() * 50000,
  paidCount: 22,
  paidSum: 350000 + Math.random() * 50000,
  proposalCount: 6,
  proposalSum: 1100000 + Math.random() * 50000,
  recurringCount: 3,
  recurringSum: 120000 + Math.random() * 10000,
  submittedCount: 5,
  submittedSum: 120000 + Math.random() * 10000,
  invoiceKinds: FAKE_INVOICES_KINDS,
};

export const FAKE_EXPORTS = { itemsCount: 329 };
